export default __webpack_public_path__ + "static/media/GB.51ac48d8.png";